import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { format } from 'date-fns'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'

export class FileUploadAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.uploadFile = this.uploadFile.bind(this)
    this.uploadExists = this.uploadExists.bind(this)
  }

  public uploadFile(file: File): Promise<number> {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Content-Disposition': `form-data; name="file"; filename="${file.name}"`,
      },
    } as AxiosRequestConfig
    const endpoint = `/configuration/upload-csv-data`
    return this.put(endpoint, file, config)
      .then((response: AxiosResponse) => response.status)
      .catch((error) => {
        throw error
      })
  }

  public uploadExists(): Promise<boolean> {
    const endpoint = `/configuration/upload-csv-data`
    return this.get(endpoint)
      .then((response: AxiosResponse) => response.status === 204)
      .catch((error) => {
        const { status } = error.response
        if (status === 404) {
          return false
        }
        throw error
      })
  }

  public firstFilesUpload(files: File[], date: Date): Promise<number> {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Content-Disposition': `form-data; name="file"`,
      },
    } as AxiosRequestConfig
    const endpoint = `/configuration/multi-file-upload`
    const formData = new FormData()
    files.forEach((f) => {
      formData.append(`files`, f)
    })
    formData.append('time_of_import', `${format(date, 'yyyy-MM-dd')}`)

    return this.post(endpoint, formData, config)
      .then((response: AxiosResponse) => response.status)
      .catch((error) => {
        throw error
      })
  }
}

export const fileUploadAPI = new FileUploadAPI(httpConfig)
